// drawingsStore.js — per-user, per-chart-context horizontal price-line persistence
// (Supabase `chart_drawings`, migration 0005). Mirrors followStore.js exactly: wraps the
// existing anon supabaseClient; the front end reads/writes only its own rows (RLS:
// chart_drawings_self_all, user_id = auth.uid()).
//
// v1 scope: horizontal lines only. `context` is 'dashboard' | 'more_info' — the SAME
// symbol has independent line sets per context, per the founder's ask.
import { supabase } from "./supabaseClient";

// SELECT every saved line for this user + symbol + context. Throws on error (callers do
// NOT fall back to a local-only state — a missing relation / permission error must surface).
export async function fetchDrawings(userId, symbol, context) {
  const { data, error } = await supabase
    .from("chart_drawings")
    .select("id, price")
    .eq("user_id", userId)
    .eq("symbol", symbol)
    .eq("context", context);
  if (error) throw error;
  return data ?? [];
}

// Insert one new horizontal line. Returns the inserted row (need its id for later delete).
export async function insertDrawing(userId, symbol, context, price) {
  const { data, error } = await supabase
    .from("chart_drawings")
    .insert({ user_id: userId, symbol, context, price })
    .select("id, price")
    .single();
  if (error) throw error;
  return data;
}

// Delete one line by id (RLS still scopes this to the caller's own rows).
export async function deleteDrawing(userId, drawingId) {
  const { error } = await supabase
    .from("chart_drawings")
    .delete()
    .eq("user_id", userId)
    .eq("id", drawingId);
  if (error) throw error;
}
